import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { initAnalytics } from "@/lib/analytics";
import { initSentry } from "@/lib/sentry";

// Initialise Sentry error monitoring (no-op if VITE_SENTRY_DSN is unset)
initSentry();

// Initialise PostHog analytics (no-op if VITE_POSTHOG_KEY is unset)
initAnalytics();
import App from "./App";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
